import { DOCUMENT } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	DestroyRef,
	inject,
	OnInit,
	Renderer2,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ClientService } from '~app-client/core/services';

@Component({
	selector: 'keyboard-reactor',
	template: ``,
	styles: [':host { display: none; } '],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [],
})
export class KeyboardReactorComponent implements OnInit {
	private readonly destroyRef = inject(DestroyRef);
	private readonly clientService = inject(ClientService);
	private readonly renderer = inject(Renderer2);
	private readonly document = inject(DOCUMENT);

	ngOnInit(): void {
		this.clientService.keyboardHeight$
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((height) => {
				this.updateKeyboardHeight(height);
			});
	}

	private updateKeyboardHeight(height: number): void {
		const kbHeightStyleId = 'kbHeightStyle';

		const queriedDoc = this.document.querySelector(`#${kbHeightStyleId}`);
		queriedDoc?.remove();

		if (height > 0) {
			const style: HTMLStyleElement = this.renderer.createElement('style');
			this.renderer.setProperty(style, 'id', kbHeightStyleId);
			style.innerText = `
			:root {
				--safe-area-inset-bottom: 0px !important;
			}
			`;
			this.renderer.appendChild(this.document.head, style);
		}
	}
}
